/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, ExternalStyles, Heading, HFlow, JustifyContent, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'
import React from 'react'

import { ContentCardSection } from '../../soap/aside/components/ContentCardSection'

interface AcompanhamentoCardProps {
  id: string
  title: string
  headerContent?: React.ReactElement
  justifyHeaderContent?: JustifyContent
  headerStyle?: ExternalStyles
  children: React.ReactNode
  loading?: boolean
  placeholder?: string
  bodyPadding?: string
}

export function AcompanhamentoCard(props: AcompanhamentoCardProps) {
  const {
    id,
    title,
    headerContent,
    justifyHeaderContent,
    headerStyle,
    children,
    loading,
    placeholder,
    bodyPadding,
  } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Box style={styles.box} id={id}>
      <HFlow
        hSpacing={0.5}
        justifyContent={justifyHeaderContent}
        style={[styles.header, headerStyle]}
        alignItems='center'
      >
        <Heading level={3}>{title}</Heading>
        {headerContent}
      </HFlow>
      <ContentCardSection isLoading={loading} bodyPadding={bodyPadding}>
        {children || placeholder}
      </ContentCardSection>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  box: css`
    border: 0.063rem solid ${theme.pallete.gray.c80};
    box-sizing: border-box;
    padding: 0;
  `,
  header: css`
    background: ${theme.pallete.gray.c90};
    padding: 0.5rem 1rem;
    border-radius: 2px;
    border-left: 0.25rem solid ${colors.purple.c40};
  `,
})
